import { SHOW_NAVBAR_USER } from "../actions/showNavUserAction";
import { HIDE_NAVBAR_USER } from "../actions/showNavUserAction"

export default function showNavUserReducer(state = false, action) {
    switch (action.type) {
        case SHOW_NAVBAR_USER:
            return true
        case HIDE_NAVBAR_USER:
            return false
        default:
           return state;
    }
}
